import { ButtonBox } from '@doda/common/src/logics/seoNarrowDownButtonData/createSeoNarrowDownButton';
import { FC, memo } from 'react';
import styles from '../index.module.scss';

/**
 * SEO絞り込みボタンアイテムのProps
 * @param narrowDownButton 絞り込みデータ
 * @param handleClick 絞り込みボタンクリック処理
 */
interface Props {
  narrowDownButton: ButtonBox;
  handleClick: (event) => void;
}

export const SeoNarrowDownButtonItem: FC<Props> = memo((props) => {
  const { narrowDownButton, handleClick } = props;
  const searchButtonResponseList = [...narrowDownButton.boxButtons];
  const narrowDownButtonTitle = '職種を絞る';
  return (
    <>
      {searchButtonResponseList.length > 0 && (
        <div className={styles.jobSearchListNarrowDownButtonWrapper}>
          <p className={styles.jobSearchListNarrowDownButtonWrapper__label}>
            {narrowDownButtonTitle}
          </p>
          <ul className={styles.jobSearchListNarrowDownButtonWrapper__button}>
            {searchButtonResponseList?.map((buttonItem, i) => (
              <li
                key={i}
                className={styles.jobSearchListNarrowDownButtonWrapper__link}
              >
                <a
                  href={buttonItem.buttonURL}
                  id={buttonItem.buttonId}
                  className={styles.jobSearchListNarrowDownButtonWrapper__text}
                  onClick={handleClick}
                >
                  {buttonItem.buttonText}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
});

SeoNarrowDownButtonItem.displayName = 'SeoNarrowDownButtonItem';
